const { get } = require("../common/network");

export const fetchCountryData = async () => {
    try {
        const data = await get("docgen/countries");
        return data;
    } catch (err) {
    }
};

